module.exports = __webpack_public_path__ + "img/iconLiShiLiaoCangXieLiao.b65da818.svg";